// 菜单栏
import Layout from "@/components/layout/Layout";
import SubMenuLayout from "@/components/layout/SubMenuLayout";
import shanghai from "./shanghai";
import qingdao from "./qingdao";
import vgm from "@/router/modules/vgm";
import assistant from "@/router/modules/assistant";
import pre9810 from "@/router/modules/pre9810";
import manifestMake from "@/router/modules/manifestMake";
import roroManifest from "@/router/modules/roroManifest";
import shManifestRecognize from "@/router/modules/shManifestRecognize";

export default {
    path: "/",
    component: Layout,
    // 重定向
    redirect: "logistics",
    children: [
        // {
        //     path: "test",
        //     name: "Test",
        //     component: () => import("@/views/BusinessCooperation/index.vue"),
        //     meta: { title: "测试" },
        // },
        {
            path: "logistics_ship",
            component: SubMenuLayout,
            redirect: "/logistics",
            meta: { title: "物流/船期订阅" },
            children: [
                {
                    path: "/logistics",
                    component: () => import("@/views/Logistics"),
                    name: "Logistics",
                    meta: {
                        title: "物流跟踪及订阅",
                        subTitle: "NB/SH/QD/TJ/XM/SZ/DL",
                    },
                },
                {
                    path: "/shipSubscrib",
                    name: "ShipSubscrib",
                    component: () => import("@/views/ShipSubscrib"),
                    meta: { title: "船期订阅" },
                },
                {
                    path: "/truckSubscribe",
                    name: "TruckSubscribe",
                    component: () => import("@/views/TruckSubscribe"),
                    meta: { title: "集卡定位", subTitle: "全国" },
                },
            ],
        },
        {
            path: "boxquery_manifest",
            component: SubMenuLayout,
            redirect: "/boxquery",
            meta: { title: "物流可视化" },
            children: [
                {
                    path: "/boxquery",
                    name: "BoxQuery",
                    component: () => import("@/views/BoxQuery"),
                    meta: {
                        title: "宁波物流可视化",
                        subTitle: "宁波港数据同步EDI",
                    },
                },
                {
                    path: "/manifestQuery",
                    name: "ManifestQuery",
                    component: () => import("@/views/ManifestQuery"),
                    meta: { title: "全国舱单查询", subTitle: "水运/空运" },
                },
            ],
        },
        {
            path: "abroad",
            name: "Abroad",
            component: () => import("@/views/Abroad"),
            meta: {
                title: "海外运踪",
                subTitle: "汇总全球15家主流船公司数据",
            },
        },
        {
            path: "shipSchedule",
            name: "ShipSchedule",
            component: () => import("@/views/ShipSchedule"),
            meta: { title: "船期查询", subTitle: "中国 ➡️ 全球" },
        },
        {
            path: "pre9810",
            name: "Pre9810",
            component: () => import("@/views/Pre9810/index.vue"),
            redirect: "/pre9810/draft",
            meta: { title: "跨境电商", hiddenChild: true },
            children: pre9810,
        },
        {
            path: "smartManifest",
            name: "SmartManifest",
            component: SubMenuLayout,
            redirect: "/manifestMake/list",
            meta: {
                title: "智能舱单",
                subTitle:"一键制作舱单",
                // 三个子菜单共用身份：有企业用企业，个人需切换
                rememberIdentity: true,
                preferCompanyRole: true,
            },
            children: [
                {
                    path: "/manifestMake",
                    name: "ManifestMakeLayout",
                    component: () => import("@/views/ManifestMake/index.vue"),
                    redirect: "/manifestMake/list",
                    meta: {
                        title: "宁波舱单",
                        hiddenChild: true,
                        preferCompanyRole: true,
                    },
                    children: manifestMake,
                },
                {
                    path: "/roroManifest",
                    name: "RoRoManifestLayout",
                    component: () => import("@/views/RoRoManifest/index.vue"),
                    redirect: "/roroManifest/list",
                    meta: {
                        title: "宁波滚装船舱单",
                        hiddenChild: true,
                        preferCompanyRole: true,
                    },
                    children: roroManifest,
                },
                {
                    path: "/shManifestRecognize",
                    name: "ShManifestRecognizeLayout",
                    component: () =>
                        import("@/views/ManifestMake/ShRecognize/index.vue"),
                    redirect: "/shManifestRecognize/list",
                    meta: {
                        title: "上海舱单识别",
                        hiddenChild: true,
                        preferCompanyRole: true,
                    },
                    children: shManifestRecognize,
                },
            ],
        },
        {
            path: "manifest_vgm",
            name: "ManifestVgm",
            component: SubMenuLayout,
            redirect: "/sh_manifest",
            meta: {
                title: "上海舱单/VGM",
            },
            children: [
                {
                    path: "/VGM",
                    name: "VGM",
                    component: () => import("@/views/VGM"),
                    meta: {
                        title: "VGM发送",
                        subTitle: "5元/柜",
                        hiddenChild: true,
                    },
                    children: vgm,
                },
                {
                    path: "/sh_manifest",
                    name: "sh_manifest",
                    component: () => import("@/views/ShanghaiManifest"),
                    meta: {
                        title: "上海舱单发送",
                        subTitle: "30元/票",
                        hiddenChild: true,
                    },
                    children: shanghai,
                },
                {
                    path: "/qd_manifest",
                    name: "qd_manifest",
                    component: () => import("@/views/QingdaoManifest"),
                    meta: {
                        title: "青岛舱单发送",
                        subTitle: "55元/票",
                        hiddenChild: true,
                        experiences: ["qdManifest"],
                        needCompanyRole: true,
                        onlyCompany: true,
                    },
                    children: qingdao,
                },
            ],
        },
        {
            path: "classAnalysis",
            name: "ClassAnalysisMenu",
            component: SubMenuLayout,
            redirect: "/classAnalysis",
            meta: { title: "归大师" },
            children: [
                {
                    path: "/classAnalysis",
                    name: "ClassAnalysis",
                    component: () => import("@/views/ClassAnalysis"),
                    meta: {
                        title: "HS编码智能归类",
                        subTitle: "AI-智能驱动",
                    },
                },
                {
                    path: "/intellectualProperty",
                    name: "IntellectualProperty",
                    component: () => import("@/views/IntellectualProperty"),
                    meta: {
                        title: "海关品牌备案查询",
                        subTitle: "避免品牌侵权",
                    },
                },
                {
                    path: "/overseasHSTax",
                    name: "OverseasHSTax",
                    component: () => import("@/views/OverseasHSTax"),
                    meta: {
                        title: "美国HS税率查询",
                        subTitle: "加征税率查询",
                    },
                },
            ],
        },
        {
            path: "assistant",
            name: "assistant",
            component: () => import("@/views/Assistant/index.vue"),
            meta: {
                title: "义乌市场采购",
                hiddenChild: true,
                experiences: ["assistant"],
                needCompanyRole: true,
            },
            children: assistant,
        },
        {
            path: "freightOfLegends",
            name: "FreightOfLegendsMenu",
            component: SubMenuLayout,
            redirect: "/freightOfLegends",
            meta: {
                title: "货代英雄联盟",
                subTitle: "NVOCC备案查询",
            },
            children: [
                {
                    path: "/freightOfLegends",
                    name: "FreightOfLegends",
                    component: () => import("@/views/FreightOfLegends/index"),
                    meta: {
                        title: "英雄联盟",
                    },
                },
                {
                    path: "/advertisement",
                    name: "Advertisement",
                    component: () => import("@/views/AdvFront/Advertisement"),
                    meta: { title: "供应商目录" },
                },
                {
                    path: "/nvoccRegistration",
                    name: "NvoccRegistration",
                    component: () => import("@/views/NvoccRegistration"),
                    meta: {
                        title: "无船承运人备案信息查询",
                    },
                },
            ],
        },
        // {
        //     path: "boxDesignated",
        //     name: "boxDesignated",
        //     component: () => import("@/views/DesignatedBox"),
        //     meta: {
        //         title: "指定箱",
        //     },
        // },
        // {
        //     path: "shManifestSend",
        //     name: "SHManifestSend",
        //     component: () => import("@/views/SHManifestSend"),
        //     meta: { title: "舱单资料发送" },
        // },
        {
            path: "history",
            name: "History",
            component: () => import("@/views/HistoryBox/HistoryBox"),
            meta: { title: "历史记录", hidden: true },
        },
        //舱单发送
        // {
        //     path: "/manifestSend",
        //     name: "manifestSend",
        //     component: () => import("@/views/ManifestSend"),
        //     meta: { title: "舱单委托录入" },
        // },
        // {
        //     path: "/manifestEdit",
        //     name: "ManifestEdit",
        //     component: () =>
        //         import(
        //             "@/views/ManifestSend/components/ManifestEditor/manifest.vue"
        //         ),
        //     meta: { title: "舱单编辑" },
        //     hidden: true,
        // },
        // // 通过store中的menu方法手动添加子元素,不要随意改动这个预录单路由name，和预录单路由展示相关联
        // {
        //     path: "/preSheet/:id",
        //     name: "PreSheet",
        //     component: () => import("@/views/PreSheet/PreSheet"),
        //     meta: { title: "预录单" },
        //     hidden: true,
        // },


        {
            path: "manifestMakeEdit",
            redirect: "/manifestMake/edit",
            name: "ManifestMakeEditRedirect",
            hidden: true,
        },
        {
            path: "roroManifestEdit",
            redirect: "/roroManifest/edit",
            name: "RoRoManifestEditRedirect",
            hidden: true,
        },
        {
            path: "shManifestRecognizeEdit",
            redirect: "/shManifestRecognize/edit",
            name: "ShManifestRecognizeEditRedirect",
            hidden: true,
        },
        // {
        //     path: "freightInsurance",
        //     name: "FreightInsurance",
        //     component: () => import("@/views/FreightInsurance/index.vue"),
        //     meta: {
        //         title: "货运保险",
        //     },
        // },
        // {
        //     path: "orderBox",
        //     name: "OrderBox",
        //     component: () => import("@/views/OrderBox"),
        //     meta: { title: "订提箱" },
        // },
        // {
        //     path: "fileAnalysis",
        //     name: "FileAnalysis",
        //     component: () => import("@/views/FileAnalysis/index.vue"),
        //     meta: { title: "资料识别" },
        // },
        // {
        //     path: "businessCooperation",
        //     name: "BusinessCooperation",
        //     component: () => import("@/views/BusinessCooperation/index.vue"),
        //     meta: { title: "商务合作" },
        // },
        {
            path: "toker",
            name: "Toker",
            component: () => import("@/views/Toker"),
            meta: {
                title: "拓客系统",
                subTitle: "",
            },
        },
    ],
};
